<template>
  <div>
    <el-form class="el-form-m20" :inline="true" size="small" :model="video">
      <el-form-item class="search-bar">
        <el-input :class="{'w-30vw':normal,'w-100per':!normal}" v-model="video.name"
                  placeholder="请输入视频名称">
          <el-button class="btn-search" @click="search" icon="el-icon-search" slot="append"></el-button>
        </el-input>
      </el-form-item>

      <el-form-item v-if="normal">
        <el-button-group>
          <el-button v-if="perm.indexOf('video:insert') > -1" type="primary" icon="el-icon-upload">
            上传视频
            <input ref="uploadFiles" accept="video/*" class="uploadFiles" type="file" name="file" multiple
                   @change="addVodFiles"/>
          </el-button>
          <el-button v-if="perm.indexOf('video:update') > -1" type="primary" icon="el-icon-picture-outline">
            批量设置封面
            <input class="batchUploadCover" accept="image/png,image/jpg,image/jpeg,image/gif" type="file"
                   @change="batchSetCover($event)"/>
          </el-button>
          <el-button v-if="perm.indexOf('video:delete') > -1" type="danger" icon="el-icon-delete"
                     @click="deleteSlt">批量删除
          </el-button>
        </el-button-group>
      </el-form-item>
    </el-form>
    <el-table
        ref="videoTable"
        :data="list"
        tooltip-effect="dark"
        style="width: 100%"
        row-key="id"
        @selection-change="handleSelectionChange">
      <el-table-column type="selection" width="45" :reserve-selection="true">
      </el-table-column>
      <el-table-column prop="id" label="编号" width="50">
      </el-table-column>
      <el-table-column width="30" type="expand">
        <template slot-scope="scope">
          <el-image class="coverImg" :src="scope.row.coverUrl" lazy fit="scale-down"></el-image>
        </template>
      </el-table-column>
      <el-table-column prop="videoId" label="视频ID" width="150" :show-overflow-tooltip="true">
      </el-table-column>
      <el-table-column prop="name" label="名称">
      </el-table-column>
      <el-table-column prop="size" label="文件大小" :formatter="toMB">
      </el-table-column>
      <el-table-column v-if="normal" label="操作">
        <template slot-scope="scope">
          <el-link v-if="perm.indexOf('video:update') > -1"
                   type="primary"
                   icon="el-icon-edit"
                   @click="modifyRow(scope.$index, scope.row)">修改
          </el-link>
          <el-link v-if="perm.indexOf('video:update') > -1"
                   type="primary"
                   icon="el-icon-picture">修改封面
            <input class="uploadCover" accept="image/png,image/jpg,image/jpeg,image/gif" type="file"
                   @change="addImgFiles($event,scope.row.id)"/>
          </el-link>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
        background
        :layout="normal ? 'sizes, prev, pager, next' : 'prev, pager, next'"
        :page-size="size"
        :total="total"
        :current-page.sync="index"
        @size-change="sizeChange"
        @current-change="currentChange">
    </el-pagination>
    <el-dialog v-if="normal" @close="cancelForm" :title="title" width="40%" :visible.sync="dialogFormVisible"
               :lockScroll="false">
      <el-form ref="videoForm" :show-message="false" :model="form" label-position="right" label-width="80px">
        <el-form-item prop="name" label="视频名称" :required="true">
          <el-input v-model="form.name" placeholder="请输入视频名称" autocomplete="off"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="cancelForm">取 消</el-button>
        <el-button type="primary" @click="confirmForm">确 定</el-button>
      </div>
    </el-dialog>

    <el-dialog :title="`上传进度：${part}/${uploadTotal}`" v-if="normal" :visible.sync="dialogUploadVisible">
      <el-progress :text-inside="true" :stroke-width="20" :percentage="percent"></el-progress>
      <div style="padding: 15px 0 0 0">{{ fileName }}</div>
      <div slot="footer" class="dialog-footer">
        <el-button-group>
          <el-button size="small" @click="stopUpload">全部停止</el-button>
        </el-button-group>
      </div>
    </el-dialog>
  </div>
</template>

<script>

import helper from "../common/CZHelper";

export default {
  name: "Video",
  props: {
    normal: {
      type: Boolean,
      default: true
    }
  },
  created() {
    /*this.getList();*/
  },
  beforeRouteEnter(to, from, next) {
    //获取不了this，会携带请求头
    next(self => {
      self.getList();
    });
  },
  data() {
    return {
      apiUrl: process.env.VUE_APP_URL,
      uploaderVod: null,
      uploaderImg: null,
      fileName: '',
      part: 1,
      uploadTotal: 1,
      percent: 0,
      dialogUploadVisible: false,
      title: '',
      dialogFormVisible: false,
      multipleSelection: [],
      video: {
        name: null
      },
      form: {
        name: null
      },
      list: [],
      total: 0,
      size: this.normal ? 10 : 6,
      index: 1,
      perm: localStorage.getItem('perm').split(","),
      userId: '1285758887089852',
      region: 'cn-shanghai',
      vid: ''
    }
  },
  methods: {
    batchSetCover(e) {
      if (this.multipleSelection.length <= 1) {
        this.$message.error('批量设置封面至少选择2个视频，设置中断');
        return;
      }
      this.addImgFiles(e, this.multipleSelection.map(item => item.id).join(","));
    },
    toMB(row, column, cellValue, index) {
      return Math.round(cellValue / 1024 / 1024 * 100) / 100 + "M";
    },
    // 窗口化供外界使用的清除选择
    cs() {
      this.$refs['videoTable'].clearSelection();
    },
    // 分页大小改变回调
    sizeChange(val) {
      this.size = val;
      this.getList();
    },
    // 页码改变回调
    currentChange(val) {
      this.index = val;
      this.getList();
    },
    // table控件数据选中回调
    handleSelectionChange(val) {
      if (!this.normal) this.$emit("rowSelected", val);
      this.multipleSelection = val;
    },
    rowSelection(rows) {
      if (!rows.length) return;
      this.courseList = rows;
    },
    deleteSlt() {
      this.$confirm('此操作将永久删除数据, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        lockScroll: false
      }).then(() => {
        if (this.multipleSelection.length <= 0) return;
        let ids = [];
        this.multipleSelection.map((v, i) => ids.push(v.id));
        this.$axios.post(
            this.apiUrl + "ma/video/remove",
            {
              ids: ids.join(",")
            }
        ).then(response => {
          if (response.data.code === 200) {
            this.getList();
            this.cs();
          }
        });
      }).catch(() => {
        //    点击取消按钮的操作，没有会报错
      });
    },
    modifyRow(rowIndex, row) {
      this.form = JSON.parse(JSON.stringify(row));
      this.show('修改视频');
    },
    show(title) {
      this.dialogFormVisible = true;
      this.title = title;
      if (this.$refs['videoForm']) this.$refs['videoForm'].clearValidate();
    },
    cancelForm() {
      this.dialogFormVisible = false;
      this.form = {name: null};
    },
    confirmForm() {
      this.$refs['videoForm'].validate((valid) => {
        if (valid) {
          let postUrl = this.form.id ? 'modify' : 'add';
          postUrl = this.apiUrl + 'ma/video/' + postUrl;
          this.$axios.post(postUrl, this.form).then(response => {
            if (response.data.code === 200) {
              this.$message.success('操作成功');
              this.getList();
            } else {
              this.$message.error('操作失败');
            }
            this.cancelForm();
          });
        } else {
          return false;
        }
      });
    },

    search() {
      this.index = 1;
      this.getList();
    },
    getList() {
      let params = {
        index: this.index,
        size: this.size,
        video: JSON.stringify(this.video)
      };
      helper.getList(this.apiUrl + 'ma/video/list', params, this);
    },
    createAliUploadVod() {
      let self = this;
      this.uploaderVod = new AliyunUpload.Vod({
        //阿里账号ID，必须有值 ，值的来源https://help.aliyun.com/knowledge_detail/37196.html
        userId: self.userId,
        //上传到点播的地域， 默认值为'cn-shanghai',//eu-central-1,ap-southeast-1
        region: self.region,
        //分片大小默认1M，不能小于100K
        partSize: 1048576,
        //并行上传分片个数，默认5
        parallel: 5,
        //网络原因失败时，重新上传次数，默认为3
        retryCount: 3,
        //网络原因失败时，重新上传间隔时间，默认为5秒
        retryDuration: 5,
        //是否上报上传日志到点播，默认为true
        enableUploadProgress: false,
        // 开始上传
        onUploadstarted(uploadInfo) {
          //上传方式1, 需要根据uploadInfo.videoId是否有值，调用点播的不同接口获取uploadauth和uploadAddress，如果videoId有值，调用刷新视频上传凭证接口，否则调用创建视频上传凭证接口
          // 如果 uploadInfo.videoId 存在, 调用 刷新视频上传凭证接口
          // console.log("onUploadStarted:" + uploadInfo.file.name + ", endpoint:" + uploadInfo.endpoint
          //     + ", bucket:" + uploadInfo.bucket + ", object:" + uploadInfo.object);
          if (uploadInfo.videoId) {
            self.$axios.get(self.apiUrl + 'ma/refreshDOVAuth?videoId=' + uploadInfo.videoId).then(({data}) => {
              if (data.code === 200) {
                let rs = JSON.parse(data.message);
                self.uploaderVod.setUploadAuthAndAddress(uploadInfo, rs.uploadAuth, rs.uploadAddress, uploadInfo.videoId);
              } else {
                self.$message.error('服务器连接失败，请修改文件名再试');
                self.dialogUploadVisible = false;
              }
            });
          } else {
            let fileName = uploadInfo.file.name.split(".");
            if (fileName.length) fileName.pop();
            //从点播服务获取的uploadAuth、uploadAddress和videoId,设置到SDK里
            self.$axios.get(self.apiUrl + `ma/getDOVAuth?title=${fileName.join('')}&fileName=${uploadInfo.file.name}`).then(({data}) => {
              data = JSON.parse(data.message);
              self.uploaderVod.setUploadAuthAndAddress(uploadInfo, data.uploadAuth, data.uploadAddress, data.videoId);
            });
          }
          self.fileName = uploadInfo.file.name;
        },
        // 文件上传成功
        onUploadSucceed(uploadInfo) {
          self.part++;
          self.saveVideo(uploadInfo);
          // console.log("onUploadSucceed: " + uploadInfo.file.name + ", endpoint:" + uploadInfo.endpoint + ", bucket:" + uploadInfo.bucket + ", object:" + uploadInfo.object);
        },
        // 文件上传失败
        onUploadFailed(uploadInfo, code, message) {
          self.$message.error('视频上传失败，可能是【' + message + "】导致");
          console.log("onUploadFailed: file:" + uploadInfo.file.name + ",code:" + code + ", message:" + message);
        },
        // 文件上传进度，单位：字节
        onUploadProgress(uploadInfo, totalSize, loadedPercent) {
          self.percent = Math.ceil(loadedPercent * 100);
          // console.log("onUploadProgress:file:" + uploadInfo.file.name + ", fileSize:" + totalSize + ", percent:" + Math.ceil(loadedPercent * 100) + "%");
        },
        // 上传凭证超时
        onUploadTokenExpired(uploadInfo) {
          console.log("onUploadTokenExpired");
          //实现时，根据uploadInfo.videoId调用刷新视频上传凭证接口重新获取UploadAuth
          //https://help.aliyun.com/document_detail/55408.html
          //从点播服务刷新的uploadAuth,设置到SDK里
          self.$axios.get(self.apiUrl + 'ma/refreshDOVAuth?videoId=' + uploadInfo.videoId).then(({data}) => {
            data = JSON.parse(data.message);
            self.uploaderVod.resumeUploadWithAuth(data.uploadAuth);
          });
        },
        //全部文件上传结束
        onUploadEnd(uploadInfo) {
          // console.log("onUploadEnd: uploaded all the files");
          self.$message.success('所有视频上传成功');
          self.dialogUploadVisible = false;
        },
        onUploadCanceled(uploadInfo) {
          // 提交videoId到服务器删除
        }
      });
    },
    createAliUploadImg() {
      let self = this;
      this.uploaderImg = new AliyunUpload.Vod({
        //阿里账号ID，必须有值 ，值的来源https://help.aliyun.com/knowledge_detail/37196.html
        userId: self.userId,
        //上传到点播的地域， 默认值为'cn-shanghai',//eu-central-1,ap-southeast-1
        region: self.region,
        //分片大小默认1M，不能小于100K
        partSize: 1048576,
        //并行上传分片个数，默认5
        parallel: 5,
        //网络原因失败时，重新上传次数，默认为3
        retryCount: 3,
        //网络原因失败时，重新上传间隔时间，默认为5秒
        retryDuration: 5,
        //是否上报上传日志到点播，默认为true
        enableUploadProgress: false,
        // 开始上传
        onUploadstarted(uploadInfo) {
          //上传方式1, 需要根据uploadInfo.videoId是否有值，调用点播的不同接口获取uploadauth和uploadAddress，如果videoId有值，调用刷新视频上传凭证接口，否则调用创建视频上传凭证接口
          // 如果 uploadInfo.videoId 存在, 调用 刷新视频上传凭证接口
          // console.log("onUploadStarted:" + uploadInfo.file.name + ", endpoint:" + uploadInfo.endpoint
          //     + ", bucket:" + uploadInfo.bucket + ", object:" + uploadInfo.object);
          let fileNameArray = uploadInfo.file.name.split(".");
          let ext = fileNameArray.pop();
          let fileName = fileNameArray.join('');
          //从点播服务获取的uploadAuth、uploadAddress和videoId,设置到SDK里
          self.$axios.get(self.apiUrl + `ma/getImageAuth?vid=${self.vid}&title=${fileName}&ext=${ext}`).then(({data}) => {
            data = JSON.parse(data.message);
            self.uploaderImg.setUploadAuthAndAddress(uploadInfo, data.uploadAuth, data.uploadAddress, data.ImageId);
          });
          self.fileName = uploadInfo.file.name;
        },
        // 文件上传成功
        onUploadSucceed(uploadInfo) {
          self.getList();
          // console.log("onUploadSucceed: " + uploadInfo.file.name + ", endpoint:" + uploadInfo.endpoint + ", bucket:" + uploadInfo.bucket + ", object:" + uploadInfo.object);
        },
        // 文件上传失败
        onUploadFailed(uploadInfo, code, message) {
          self.$message.error('图片上传失败，可能是【' + message + "】导致");
          console.log("onUploadFailed: file:" + uploadInfo.file.name + ",code:" + code + ", message:" + message);
        },
        // 文件上传进度，单位：字节
        onUploadProgress(uploadInfo, totalSize, loadedPercent) {
          self.percent = Math.ceil(loadedPercent * 100);
          // console.log("onUploadProgress:file:" + uploadInfo.file.name + ", fileSize:" + totalSize + ", percent:" + Math.ceil(loadedPercent * 100) + "%");
        },
        // 上传凭证超时
        onUploadTokenExpired(uploadInfo) {
          console.log("onUploadTokenExpired");
        },
        //全部文件上传结束
        onUploadEnd(uploadInfo) {
          // console.log("onUploadEnd: uploaded all the files");
          self.$message.success('图片上传成功');
          self.dialogUploadVisible = false;
          self.cs();
        },
        onUploadCanceled(uploadInfo) {
          // 提交videoId到服务器删除
        }
      });
    },
    addVodFiles(e) {
      this.createAliUploadVod();
      this.addFile(e, this.uploaderVod);
    },
    addImgFiles(e, vid) {
      this.createAliUploadImg();
      this.vid = vid;
      this.addFile(e, this.uploaderImg);
    },
    addFile(e, uploader) {
      this.part = 1;
      this.uploadTotal = e.target.files.length;
      this.percent = 0;
      if (e.target.files.length) {
        this.dialogUploadVisible = true;
        e.target.files.forEach(file => {
          uploader.addFile(file, null, null, null, null);
        });
        uploader.startUpload();
        e.target.value = '';
      } else {
        this.$message.warning('请先选择要上传的文件');
      }
    },
    //同步视频到服务器
    saveVideo(uploadInfo) {
      this.$axios.post(
          this.apiUrl + "ma/video/add",
          {
            videoId: uploadInfo.videoId,
            size: uploadInfo.file.size
          }
      ).then(({data}) => {
        if (data.code !== 200) {
          this.$message.error('本条视频同步失败，建议整体上传完毕后单独同步');
        }
        this.index = 1;
        this.getList();
      })
    },
    stopUpload() {
      if (this.uploaderVod) {
        this.uploaderVod.stopUpload();
      }
      this.dialogUploadVisible = false;
      this.percent = 0;
    }
  }
}
</script>

<style scoped>
@import "../css/common.css";

.coverImg {
  border-radius: 5px;
  border: 8px solid #f8f8f8;
  width: 40vw;
}

.uploadFiles, .uploadCover, .batchUploadCover {
  position: absolute;
  z-index: 999;
  left: 0;
  top: 0;
  opacity: 0;
  filter: alpha(opacity=0);
  cursor: pointer;
}

.uploadFiles {
  width: 97px;
  height: 32px;
}

.uploadCover {
  width: 75px;
  height: 23px;
}

.batchUploadCover {
  width: 123px;
  height: 32px;
}

.uploadFiles:focus {
  outline: none;
}

.el-table th, .el-table td {
  padding: 5px 0;
}

.el-link {
  margin: 0 5px;
}

.el-form-m20 {
  margin: 0 10px;
  /*text-align: right;*/
}

.school {
  color: #9f9f9f;
  width: 78px;
}

.filter {
  display: flex;
  color: #e79b37;
  padding: 10px 0 10px 25px;
  font-size: 0.9em;
  background: white;
  border-radius: 4px;
  margin-bottom: 20px;
}

.filter-item-active {
  color: #8b0000;
}

.filter-item {
  margin: 0 10px;
  cursor: pointer;
}
</style>